import ScrollableContainer from '../ScrollableContainer';
export const ScrollableContainerCommonProps = {
    onScrollAreaChanged: ScrollableContainer.propTypes['onScrollAreaChanged'],
    onScrollChanged: ScrollableContainer.propTypes['onScrollChanged'],
};
//# sourceMappingURL=ScrollableContainerCommon.js.map